'use es6';

import { makeReferenceResolver } from 'reference-resolvers/ReferenceResolver';
import I18n from 'I18n';
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import emptyFunction from 'react-utils/emptyFunction';
const translateOptionLabel = option => {
  return I18n.text(option.label);
};
export default (options => {
  const all = () => options.map(option => {
    return ReferenceRecord({
      id: `${option.id}`,
      label: translateOptionLabel(option),
      referencedObject: option
    });
  });
  const byId = id => {
    const option = options.get(id);
    return ReferenceRecord({
      id: `${option.id}`,
      label: translateOptionLabel(option),
      referencedObject: option
    });
  };
  return makeReferenceResolver({
    all(next) {
      next(all());
      return emptyFunction;
    },
    byId(id, next) {
      next(byId(id));
      return emptyFunction;
    }
  });
});